import { render, staticRenderFns } from "./TabelaClassificacao.vue?vue&type=template&id=2e813a3c"
import script from "./TabelaClassificacao.vue?vue&type=script&lang=js"
export * from "./TabelaClassificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports